export const REQUEST_PAGE = 'PACKAGE_DETAIL/REQUEST_PAGE';
export const GOT_PACKAGE = 'PACKAGE_DETAIL/GOT_PACKAGE';

// Delete Modal
export const OPEN_DELETE_MODAL = 'PACKAGE_DETAIL/OPEN_DELETE_MODAL';
export const CLOSE_DELETE_MODAL = 'PACKAGE_DETAIL/CLOSE_DELETE_MODAL';
export const REQUEST_DELETE_PACKAGE = 'PACKAGE_DETAIL/REQUEST_DELETE_PACKAGE';
